import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { getCookie } from '../../../config/cookies';
import { ApiEndpoints, reqPost } from '../../../config/apiClient';
import { toast } from 'react-toastify';

const NFSeEmpresaCertificadoForm: React.FC<iProps> = (propsDados) => {
    const [file, setFile] = useState<File | null>(null);
    const [message, setMessage] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const selectedFile = e.target.files[0];
            if (selectedFile.name.endsWith('.pfx')) {
                setFile(selectedFile);
                setMessage('');
            } else {
                setFile(null);
                setMessage('Por favor, selecione um arquivo .pfx.')
            }
        }
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!file) {
            setMessage('Selecione um arquivo .pfx antes de enviar.')
            return;
        }
        const form = e.target as HTMLFormElement;
        let formValidado = true
        const dados = {
            file,
            senha: form.senha.value,
            id_empresa: propsDados.empresa.id_empresa,
        }

        if (dados.senha === "") {
            formValidado = false
            setMessage('A senha do certificado é obrigatória.')
        }

        if (formValidado) {
            salvarCertificado(dados)
        }
    }

    async function salvarCertificado(dados:any) {
        setLoading(true)

        const token = getCookie("token")
        const id_usuario = getCookie("id_user")
        let dadosForm = new FormData()
        dadosForm.append('certificado', dados.file)
        dadosForm.append('senha', dados.senha)
        dadosForm.append('id_empresa', dados.id_empresa)

        try {
            let api:Response
            let apiData = await fetch(
                ApiEndpoints.nfseEmpresaSalvarCertificado.endpoint,
                {
                    method: "POST",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "id_usuario": id_usuario,
                    },
                    body: dadosForm
                }
            ).then(response => {
                api = response
                return response.json()
            })
            if (api!.status === 200) {
                setMessage('Arquivo enviado com sucesso!')
                console.log(apiData)
                toast.success("Importação finalizada com sucesso!", {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
                propsDados.handleUpdate()
            } else {
                toast.warn(String(apiData.message), {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
            }
        } catch (error) {
            console.log(error)
            toast.warn('Não foi possível importar, verifique se o layout está correto ou contate o suporte!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }

        setLoading(false)
    }

    async function handleRemoveCertificado() {
        if (!window.confirm("Tem certeza que deseja remover o certificado?")) {
            return;
        }

        setLoading(true)
        const dados = {
            id_empresa: propsDados.empresa.id_empresa,
        }
        const api = await reqPost(ApiEndpoints.nfseEmpresaSalvarDeletar, dados)
        if (api.status === 200) {
            toast.success("Certificado removido com sucesso!", {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            propsDados.handleUpdate()
        }
        setLoading(false)
    }

    if (Object.keys(propsDados.empresa).length === 0) {
        return (
            <div></div>
        )
    }

    if (propsDados.empresa.nfs_certificado !== null) {
        return (
            <div>
                <h5>Certificado Digital (.pfx)</h5>
                <p>Já existe um certificado digital associado a esta empresa.</p>
                <br></br>
                <Button disabled={loading} style={{ marginRight: "10px" }} variant='danger' onClick={() => { handleRemoveCertificado() }} >{loading ? "Aguarde..." : "Remover Certificado"}</Button>
            </div>
        );
    }

    return (
        <div>
            <h5>Certificado Digital (.pfx)</h5>
            <br></br>
            <form onSubmit={handleSubmit}>
            <Row className="mb-15-forms">
                <Col className="col-3">
                    <Form.Group>
                        <Form.Control type="file" name="certificado" id="certificado" aria-label="Selecione o Certificado" accept=".pfx" onChange={handleFileChange}></Form.Control>
                        <Form.Control.Feedback type="invalid">
                            Selecione o arquivo!
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col className='col-3'>
                    <Form.Group>
                        <Form.Control name='senha' type="password" id='senha' className="senha" placeholder="Senha do Certificado" autoComplete='false' />
                    </Form.Group>
                </Col>
                <Col className='col-3'>
                    <Button type="submit" disabled={loading} style={{ marginRight: "10px" }} variant='success'>{loading ? "Aguarde..." : "Salvar Certificado"}</Button>
                    {message && <p>{message}</p>}
                </Col>
            </Row>
        </form>
        </div>
    );
};

interface iProps {
    empresa: any,
    handleUpdate: any
}

export default NFSeEmpresaCertificadoForm;
